<template>
    <metadata-checkbox
        :metadata="getMetadata"
        :required="required"
        :value="value"
        @update:value="emitValue" />
</template>

<script>
import MetadataCheckbox from '@/components/metadata/inputs/checkbox/MetadataCheckbox.vue';

export default {
    components: {
        MetadataCheckbox
    },
    props: {
        metadata: { type: Object, required: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: Boolean, required: false, default: false },
    },
    computed: {
        getMetadata() {
            return {
                ...this.metadata,
                descriptionFr: this.$i18n.t('form.covid195To11ConfirmReadDocument.label'),
                descriptionEn: this.$i18n.t('form.covid195To11ConfirmReadDocument.label')
            };
        }
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
